export const GETLISTAPPLY_REQUEST = 'GetListApplyReducer/GETLISTAPPLY_REQUEST';
export const GETLISTAPPLY_SUCCESS = 'GetListApplyReducer/GETLISTAPPLY_SUCCESS';
export const GETLISTAPPLY_FAILED = 'GetListApplyReducer/GETLISTAPPLY_FAILED';
